import type { NotificationMessage } from "./notificationCopy.ts";
import { notify } from "./notify.ts";

export type StaffActionToastCopy = {
  success: NotificationMessage;
  error: NotificationMessage;
};

export async function requireMutationResult<T>(promise: Promise<T>): Promise<T> {
  const result = await promise;
  if (result === null || result === undefined) throw new Error("Mutation did not return a result.");
  return result;
}

export function runStaffAction(run: () => Promise<unknown>, copy: StaffActionToastCopy) {
  void run()
    .then(() => notify.success(copy.success))
    .catch(() => notify.error(copy.error));
}
